import {
  ensureJson,
  IExtension,
  IGlobalConfig,
  INotificationProvider,
  IProviderFactory,
  ISettings,
  ITheme,
} from 'slipstream-components';
import ThemeAPI from '../apis/ThemeAPI';
import globalConfig from './global_config.json';
import DefaultAuthProvider from './providers/DefaultAuthProvider';
import DefaultNotificationProvider from './providers/DefaultNotificationProvider';
import DefaultPreferenceProvider from './providers/DefaultPreferenceProvider';
import DefaultRbacProvider from './providers/DefaultRbacProvider';
import DefaultResourceProvider from './providers/DefaultResourceProvider';
import { DefaultTranslatorSet } from './providers/DefaultTranslatorSet';

const settings = {
  navTheme: 'dark', // theme for nav menu
  // primaryColor: '#1890FF', // primary color of ant design
  currentTheme: 'default',
  layout: 'sidemenu', // nav menu position: sidemenu or topmenu
  collapsed: true,
  contentWidth: 'Fluid', // layout of content: Fluid or Fixed, only works when layout is topmenu
  // fixedHeader: false, // sticky header
  // autoHideHeader: false, // auto hide header
  // fixSiderbar: true, // sticky siderbar
};

export default class DefaultProviderFactory implements IProviderFactory {
  private authProvider = new DefaultAuthProvider(this);
  private rbacProvider = new DefaultRbacProvider(this.authProvider);
  private resourceProvider = new DefaultResourceProvider();
  private notificationProvider = new DefaultNotificationProvider();
  private translatorSet = new DefaultTranslatorSet();
  private preferenceProvider = new DefaultPreferenceProvider();
  private extensions: IExtension;
  private aliasMapping = null;
  public getResourceProvider() {
    return this.resourceProvider;
  }

  public getAuthProvider() {
    return this.authProvider;
  }

  public getRbacProvider() {
    return this.rbacProvider;
  }

  public getSystemId() {
    return 'cso';
  }

  public getSystemCtxkey() {
    return 'cso_' + this.authProvider.getCustomer();
  }

  // public getExtensions() {
  //   return extensions;
  // }

  public getGlobalConfig<T extends IGlobalConfig>(): T {
    const appInfo: any = sessionStorage.getItem('appInfo');
    if (appInfo) {
      const appInfoObj = ensureJson(appInfo);
      if (appInfoObj && appInfoObj.version) {
        globalConfig.version = appInfoObj.version;
      }
    }
    return globalConfig;
  }

  public getDefaultSetttings(): ISettings {
    return settings;
  }
  public getNotificationProvider(): INotificationProvider {
    return this.notificationProvider;
  }

  public getThemes(): Promise<ITheme[]> {
    return ThemeAPI.getActiveThemes()
      .then(themes => {
        return themes.map(theme => {
          return {
            color: theme.content['primary-color'] || '#0099ff',
            path: '',
            name: theme.display_name,
          };
        });
      })
      .catch(err => {
        return [
          {
            color: '#0099ff',
            path: '',
            name: 'Default',
          },
        ];
      });
  }

  public getCriteriaTranslator() {
    return this.translatorSet;
  }

  public getPreferenceProvider() {
    return this.preferenceProvider;
  }

  public getExtensions() {
    return this.extensions;
  }

  public setExtensions(extensions: IExtension) {
    this.extensions = extensions;
  }

  public getHelpMapping(linkId: string) {
    if (this.aliasMapping == null) {
      return fetch('/static/help/Alias.xml')
        .then(r => r.text())
        .then(content => {
          const parser = new DOMParser();
          const xml = parser.parseFromString(content, 'text/xml');
          this.aliasMapping = {};
          xml.querySelectorAll('Map').forEach(node => {
            const linkName = node.getAttribute('Name');
            const target = node.getAttribute('Link');
            this.aliasMapping[linkName] = target;
          });
          const linkValue = this.aliasMapping[linkId];
          if (!linkValue) {
            console.error('No help link mapping for id ' + linkId);
          }
          return linkValue;
        });
    } else {
      return Promise.resolve(this.aliasMapping[linkId]);
    }
    // return import('./alias.xml').then(r => {
    //   if(this.aliasMapping == null) {
    //     const parser = new DOMParser();
    //     this.aliasMapping = parser.parseFromString(r, "text/xml");
    //   }
    //   return ''
    // })
  }
}
